/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fromBase64, toBase64, toBase64String } from './base64-handlers';

const setSearchState = (items: any = '') => {
  const newItems = Array.isArray(items)
    ? items
    : {
        ...items,
        prevUrl: getSearchState()?.prevUrl,
      };
  window.history.pushState(
    null,
    '',
    `${window.location.pathname}?${toBase64(newItems)}}`
  );
};
const getSearchState = (initValue?: any) => {
  const search =
    typeof window.location?.search === 'string' &&
    window.location?.search?.includes('%22')
      ? window.location?.search?.replaceAll('%22', '')
      : window.location?.search;
  return fromBase64(search, initValue);
};

const savePrevSearchState = (url?: string, state?: string) =>
  `${url}?${toBase64(window?.location?.pathname)}&${
    state ? `${toBase64String(state)}` : ''
  }`;

const navigateWithSearchState = (url: string, state: any, isArray?: boolean) =>
  `${url}?${toBase64(
    isArray
      ? state
      : {
          ...state,
          prevUrl: `${window?.location?.pathname}${window?.location?.search}`,
        }
  )}`;
export {
  setSearchState,
  getSearchState,
  savePrevSearchState,
  navigateWithSearchState,
};
